<template>
    <a-modal
      class="ant-modal-custom"
      :width="'600px'"
      :visible="visible"
      :confirmLoading="loading"
      @ok="handleEditOk"
      @cancel="handleEditCancel"
    >
      <div class="title">
        自定义量表
      </div>
      <a-form-model layout="horizontal" :model="model" ref="ruleForm" :rules="rules">
        <div class="item">
          <a-form-model-item
            prop="moduleCode"
            label="所属模块">
            <a-select v-model='model.moduleCode' placeholder='请选择'  showSearch :filterOption="filterOption" style="background: transparent;">
              <a-select-option :value='item.code' :key="item.code" v-for="item in moduleList">{{item.name}}</a-select-option>
            </a-select>
          </a-form-model-item>
        </div>
        <div class="item">
          <a-form-model-item
            prop="formName"
            label="表单名称">
            <a-input placeholder="请输入表单名称" v-model="model.formName" />
          </a-form-model-item>
        </div>
        <div class="item">
          <a-form-model-item
            prop="fileName"
            label="表单设计参考">
            <a-upload 
              list-type="picture-card"
              name="file"  
              :multiple="false"
              :headers="tokenHeader" 
              :data="{}" 
              :action="importExcelUrl" 
              @change="handleUploadChange">
                <!-- <a-button type="primary" icon="import">上传文件</a-button> -->
                <a-icon type="plus" style="color: white;font-size: 30px;"/>
                <div style="color: rgba(255,255,255,0.4)">
                  上传文件
                </div>
            </a-upload>
          </a-form-model-item>
        </div>
      </a-form-model>

      <template slot="footer">
        <gradient-btn @click="handleEditOk">确认添加</gradient-btn>
      </template>
    </a-modal>
</template>

<script>
  import { ACCESS_TOKEN } from '@/store/mutation-types'
  import baseRules from '@/constants/baseRules'
  import GradientBtn from '@comp/pad/GradientBtn'
  import Vue from 'vue'
  import { postAction } from '@api/manage'
  export default {
    name: 'ModuleFormDiy',
    props:{
      moduleList:{
        type:Array,
        default:()=>{
          return []
        }
      },
      project:{
        type:Object,
        default:()=>{
          return { }
        }
      },
      diseaseCode:{
        type:String,
        default:''
      }
    },
    components:{GradientBtn},
    data(){
      return {
        model:{},
        rules:{
          moduleCode:[baseRules.requiredChange],
          formName:[baseRules.required],
          path:[baseRules.required],
        },
        tokenHeader: {'X-Access-Token': Vue.ls.get(ACCESS_TOKEN)},
        loading:false,
        visible:false,
      }
    },
    computed: {
      importExcelUrl() {
        return `${window._CONFIG['domianURL']}/sys/common/upload`
      }
    },
    mounted(){

    },
    methods:{
      handleEditOk(){
        this.$refs.ruleForm.validate(valid  => {
          if (valid) {
            let formData = Object.assign({projectId:this.project.id,diseaseCode:this.diseaseCode},this.model);
            if(!formData.path || !formData.fileName){
              return this.$message.warn('请上传文件')
            }
            this.confirmLoading = true;
            postAction('/projectconfigview/formFile/save',formData).then((res)=>{
                if(res.success){
                  this.$message.success(res.message)
                  this.handleEditCancel();
                }
            }).finally(() => {
              this.confirmLoading = false;
            })
          } else {
            return false;
          }
        })
      },
      handleEditCancel(){
        this.visible = false
      },
      open(){
        this.visible = true
      },
      filterOption(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      handleUploadChange(info) {
        // if (info.file.status !== 'uploading') {
        //   console.log(info.file, info.fileList);
        // }
        if (info.file.status === 'done' || info.file.status === 'removed') {
          let paths = ''
          let files = ''
          if(info.fileList){
            info.fileList.forEach(item=>{
              if(paths){
                paths +=','+ item.response.message
                files +=','+ item.name
              }else{
                paths = item.response.message
                files = item.name
              }
            })
          }
          this.$set(this.model,'path',paths);
          this.$set(this.model,'fileName',files);
        } else if (info.file.status === 'error') {
          this.$message.error(`${info.file.name} file upload failed.`);
        }
      },
    }
  }
</script>

<style scoped lang="less">
  .ant-modal-custom {
    /deep/ .ant-modal-content{
      //191f35  252628
      background: linear-gradient(to bottom, #191f35, #252628);
    }
    /deep/ .ant-form-item-label > label{
      font-weight: 400;
      font-size: 14px;
      color: rgba(255,255,255,0.7);
      line-height: 16px;
    }
    /deep/ .ant-form-item{
      margin-bottom: 0;
    }
    /deep/ .ant-upload.ant-upload-select-picture-card{
      background: transparent;
    }
    /deep/ .has-error .ant-input, .has-error .ant-input:hover{
      background: transparent;
    }
    /deep/ .ant-input{
      background: transparent;
      color: rgba(255, 255, 255, 0.4);
    }
    /deep/ .ant-select-selection {
      background: transparent;
      color: rgba(255,255,255,0.4);
    }
    /deep/ .ant-modal-footer{
      text-align: center;
      border-top: 0;
      padding-bottom: 30px;
    }
    /deep/ .ant-modal-close{
      color: white;
    }
  }
  .item {
    margin-top: 20px;
    padding: 10px 15px;
    background: rgba(255,255,255,0.15);
    border-radius: 12px 12px 12px 12px;
  }
  .title{
    text-align: center;
    font-weight: 600;
    font-size: 18px;
    color: #FFFFFF;
    line-height: 21px;
  }
</style>